// src/components/Sidebar.js
import React from "react";
import { Nav } from "react-bootstrap";
import axios from "axios";

const Sidebar = () => {
  let authToken = localStorage.getItem('authToken');
  const handleFac = () => {
    axios.get(`http://127.0.0.1:8000/api/listProjects`, {
      headers: {
        'Authorization': `Bearer ${authToken}`
      }
    }).
      then(
        response => {
          console.log("Working");
        }
      );
  }

  const logout = () => {
    axios.get(`http://127.0.0.1:8000/api/logout`, {
      headers: {
        'Authorization': `Bearer ${authToken}`
      }
    }).
      then(
        response => {
          console.log("Working");
        }
      );
  }
  return (
    <div
      style={{
        minHeight: "100vh",
        backgroundColor: "#343a40",
        color: "white",
        paddingTop: "1rem",
        width: "220px",
      }}
    >
      <h4 className="text-center mb-4">Dashboard</h4>
      <Nav defaultActiveKey="/home" className="flex-column px-3">
        <Nav.Link href="#" className="text-white">
          Home
        </Nav.Link>
        <Nav.Link href="#" className="text-white" onClick={() => handleFac()}>
          Import KEKA Projects
        </Nav.Link>
        <Nav.Link href="#" className="text-white">
          Settings
        </Nav.Link>
        <Nav.Link href="/register" className="text-white">
          Create User
        </Nav.Link>
      </Nav>
    </div>
  );
};

export default Sidebar;
